import { TTableHeadCell } from "components/ProjectSpecificComponents/Interfaces/TableInterface"
import React from "react"
import styled from "styled-components"
import { Tr } from "./StyledComponents/TableStyleComp"
interface Props {
	data: any[]
	head: TTableHeadCell[]
}

export const TableFooter = ({ data, head }: Props) => {
	const hasAnySum = Boolean(
		Object.values(head).reduce((count, { showSum }) => (showSum ? count + 1 : count), 0)
	)

	if (!hasAnySum) return <></>

	return (
		<div>
			<Tr>
				{Object.values(head).map(({ showSum, key }: any, i: number) => {
					return (
						<LightGrayTd
							key={key || i}
							style={{
								backgroundColor: showSum ? "var(--light-light-gray)" : "initial",
							}}
						>
							{showSum && (
								<>
									<b>{`Kopā: `}</b>
									{/* Ja kadreiz vajag, ka var attēlot row summu, tad šo funkciju vajag importēt no citiem projektiem. */}
									{/* {sumObjectArrayKeyVal(data, key, 3).toFixed(3)} */}
								</>
							)}
						</LightGrayTd>
					)
				})}
			</Tr>
		</div>
	)
}

const LightGrayTd = styled.div`
	border: 2px solid var(--white);
	border-top: none;
	border-radius: 0 0 10px 10px;
	text-align: right;
`
